import styled from 'styled-components';

export const SELECTOR_MODAL_HINT = 'Clique na linha desejada para selecionar.';

export const SelectorModalHint = styled.p`
    margin: -8px 0 16px;
    font-size: 14px;
    color: #6b7280;
    line-height: 1.45;
    flex-shrink: 0;
`;
